module.exports = __webpack_public_path__ + "static/img/t2.add5ea6d.png";